// OnboardingLayout.tsx
import { ReactNode } from 'react'
import styles from './styles.module.scss'

interface IProps {
    children: ReactNode
}

const OnboardingLayout = ({ children }: IProps) => (
    <div className={styles.wrap}>
        <div className={styles.wrapItem}>
            <div className={'row justify-content-between'}>
                {children}
            </div>
        </div>
    </div>
)

export default OnboardingLayout
